module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sky-overlay-toggle', {
    staticClass: "ro-sign-up",
    attrs: {
      "name": "signUp",
      "courseInfo": _vm.courseInfo
    }
  }, [_c('span', [_c('div', [_vm._v("Tilmeld")])]), _vm._v(" "), _c('div', {
    staticClass: "svg-wrap"
  }, [_c('sky-svg', {
    attrs: {
      "name": "arrow"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-7b41b202"}!./scripts/ro-sign-up/RoSignUp.html
// module id = 376
// module chunks = 1